import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";

export const callSupplierMasterGetApi = async () => {
  const { data = {} } = await axiosInstance.get(API.supplier_master);
  return data;
};
